import { createWebHistory, createRouter } from 'vue-router'
import NewLoginView from '@/views/Login/NewLoginView.vue'
import NewForgotPasswordView from '@/views/ForgotPassword/NewForgotPasswordView.vue'
import NewResetPasswordView from '@/views/ResetPassword/NewResetPasswordView.vue'
import TOTPView from '@/views/TOTP/TOTPView.vue'
import OTPView from '@/views/OTP/OTPView.vue'
import RefreshAccessToken from '@/views/RefreshAccessToken/RefreshAccessToken.vue'
import RefreshAccessTokenError from '@/views/RefreshAccessTokenError/RefreshAccessTokenError.vue'
import NewSetNewPasswordView from '@/views/SetNewPassword/NewSetNewPasswordView.vue'
import ResetHashPasswordView from '@/views/ResetHashPassword/ResetHashPasswordView.vue'
import MfaView from '@/views/Mfa/MfaView.vue'
import MfaSmsConfirm from '@/views/Mfa/MfaSmsConfirmView.vue'
import { useConfigSync } from '@/config/useConfig'
import guards from './guards'

export const createAppRouter = async () => {
  const config = useConfigSync()

  const routes = [
    {
      path: '/',
      name: 'HomeView',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'LoginView',
      component: NewLoginView
    },
    {
      path: '/forgot',
      name: 'ForgotView',
      component: NewForgotPasswordView
    },
    {
      path: '/resetPassword',
      name: 'SetNewPasswordView',
      component: NewSetNewPasswordView
    },
    {
      path: '/reset',
      name: 'ResetView',
      component: NewResetPasswordView
    },
    {
      path: '/updatePassword',
      name: 'UpdatePasswordView',
      component: NewResetPasswordView,
      props: { expired: true }
    },
    {
      path: '/totp',
      name: 'SoftwareTokenMfa',
      component: TOTPView
    },
    {
      path: '/otp',
      name: 'OtpMfa',
      component: OTPView
    },
    {
      path: '/refresh',
      name: 'RefreshAccessToken',
      component: RefreshAccessToken
    },
    {
      path: '/refreshError',
      name: 'RefreshAccessTokenError',
      component: RefreshAccessTokenError
    },
    {
      path: '/newPassword',
      name: 'ResetHashView',
      component: ResetHashPasswordView
    },
    {
      path: '/mfa',
      name: 'MFA',
      component: MfaView
    },
    {
      path: '/mfa/confirm',
      name: 'MFASMSConfirm',
      component: MfaSmsConfirm
    }
  ]

  const router = createRouter({
    history: createWebHistory(),
    routes
  })

  router.beforeEach(async (to, from) => {
    const routeName = to.name as string

    // const canContinue = Authenticated(to, from)
    //
    // if (!canContinue) return false

    if (!guards[routeName]) return
    return guards[routeName](to, from)
  })

  return router
}
